const toArray = (value) => Array.isArray(value) ? value : [];

const firstDefined = (...values) => values.find((value) => value !== undefined && value !== null && value !== "");

const getLinkCollections = (customer: any) => (
    toArray(customer?.social_accounts)
        .concat(toArray(customer?.oauth_accounts))
        .concat(toArray(customer?.oauthLinks))
        .concat(toArray(customer?.socialLinks))
);

const normalizeMappedConnection = (customer: any, link: any) => {
    const origin = firstDefined(link?.origin, link?.media, link?.platform, link?.oauth?.origin);
    const oauthId = firstDefined(link?.oauthId, link?.oauth_id, link?.oauth?._id);
    const accountId = firstDefined(link?.accountId, link?.account_id);
    const accountTitle = firstDefined(link?.accountTitle, link?.account_title);

    const oauth = link?.oauth
        || toArray(customer?.oauths).find((item: any) => (
            (oauthId && item?._id === oauthId)
            || (
                item?.origin === origin
                && (!accountId || toArray(item?.data?.accounts).some((account: any) => account?.id === accountId))
            )
        ))
        || null;

    return {
        _id: firstDefined(link?._id, `${origin}:${oauthId ?? "none"}:${accountId ?? "none"}`),
        origin,
        oauthId: firstDefined(oauthId, oauth?._id),
        accountId,
        accountTitle: firstDefined(accountTitle, toArray(oauth?.data?.accounts).find((account: any) => account?.id === accountId)?.title),
        oauth,
        data: oauth?.data,
        infinite_renew: firstDefined(link?.infinite_renew, oauth?.infinite_renew, false),
        auth_expires_at: firstDefined(link?.auth_expires_at, oauth?.data?.auth?.full_expires_preview, oauth?.data?.auth?.expires_at),
        connectionMode: "mapping",
        raw: link,
    };
};

const normalizeLegacyConnection = (oauth: any) => ({
    _id: oauth?._id,
    origin: oauth?.origin,
    oauthId: oauth?._id,
    oauth,
    data: oauth?.data,
    infinite_renew: oauth?.infinite_renew,
    auth_expires_at: firstDefined(oauth?.data?.auth?.full_expires_preview, oauth?.data?.auth?.expires_at),
    connectionMode: "legacy",
    raw: oauth,
});

export const getCustomerSocialConnections = (customer: any) => {
    const mapped = getLinkCollections(customer)
        .map((link: any) => normalizeMappedConnection(customer, link))
        .filter((link: any) => !!link?.origin);

    if (mapped.length > 0) {
        return mapped;
    }

    return toArray(customer?.oauths)
        .map((oauth: any) => normalizeLegacyConnection(oauth))
        .filter((oauth: any) => !!oauth?.origin);
};

export const getCustomerConnectionByOrigin = (customer: any, origin: string) => {
    console.log("s", getLinkCollections(customer));

    const mappedConnection = getLinkCollections(customer)
        .map((link: any) => normalizeMappedConnection(customer, link))
        .find((connection: any) => (
            connection?.origin === origin
            && !!connection?.accountId
        ));

    if (mappedConnection) {
        const oauth = mappedConnection?.oauth
            || toArray(customer?.oauths).find((item: any) => item?._id === mappedConnection?.oauthId)
            || toArray(customer?.oauths).find((item: any) => item?.origin === origin)
            || null;

        const selectedAccount = {
            id: mappedConnection?.accountId,
            title: mappedConnection?.accountTitle,
        };

        if (oauth) {
            return {
                ...oauth,
                _id: mappedConnection?.oauthId ?? oauth?._id,
                origin,
                data: {
                    ...(oauth?.data ?? {}),
                    accounts: [selectedAccount],
                },
                selected_account: selectedAccount,
                __connection: mappedConnection,
            };
        }

        return {
            _id: mappedConnection?.oauthId,
            origin,
            data: {
                accounts: [selectedAccount],
                auth: {},
                me: {},
            },
            selected_account: selectedAccount,
            __connection: mappedConnection,
        };
    }

    const legacyOauth = toArray(customer?.oauths).find((item: any) => item?.origin === origin);
    if (!legacyOauth) {
        return null;
    }

    return {
        ...legacyOauth,
        _id: legacyOauth?._id,
        origin,
        data: {
            ...(legacyOauth?.data ?? {}),
            accounts: toArray(legacyOauth?.data?.accounts),
        },
        selected_account: null,
        __connection: normalizeLegacyConnection(legacyOauth),
    };
};

export const getConnectionDisplayTitle = (connection: any, fallbackTitle = "Conta conectada") => {
    if (connection?.accountTitle) {
        return connection.accountTitle;
    }

    const me = connection?.data?.me ?? {};
    return me?.name ?? me?.username ?? me?.email ?? fallbackTitle;
};
